module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABb0lEQVQ4T52SvUvDUBTFz32xFSpUHBy6ioMgOHQvOCh0kW6JFMRUhARxcHIQFPwDXGo/EpQk0lKarCIILqKgm5OLg7i4iFApokKlefKiLbVCW3zTO+++3+XcwyX881Anly2Xo6FGaIcYpO5+BJ7T1MX71nsbzDmV6RCkZC8DnJpX+nL6WvwJwKzljYfJTxBRoifIcadnFCN/WJokw6qmwCjFgdNBx2WgTSo6riwuAL8cBOTAKDjidHBUmfG5tKepyrwATdvdBtGNpsongbaqcTC2qqnymtAFy50bYlgi0zyOYPjjVlPlCVEwHG+XwGcBPAvNQVGAP+qqsiJ00aquM6KxIBzD9i6I/IyI2/M8qd6QYp22/bdwTdMW3gMHjlfwwc+/Qce1wJuenkn3Dch03LNPNDcC0LTdLRDqmqrk+wVk2O5D4/Vp6sdqJUkk7XOg1gskkATwFxFke3NMsxRjI5E/q9bdqDXvr13tZ7Oz/gUbx39AFNUYLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/zyk.png
// module id = DIwq
// module chunks = 96